import { authenticatedFetch } from '@/utils/authenticatedFetch'
import { contract } from '@repo/api-contracts'
import { initClient, type InitClientArgs } from '@ts-rest/core'

// Singleton client instance
let clientInstance: ReturnType<typeof initClient<typeof contract, InitClientArgs>> | null = null

export const useClient = async () => {
  // Return the singleton client instance if it exists
  if (clientInstance) {
    return clientInstance
  }

  const config = {
    baseUrl: import.meta.env.VITE_API_BASE_URL,
    baseHeaders: {
      'Content-Type': 'application/json',
      'x-correlation-id': () => crypto.randomUUID(), // Generate a unique correlation ID for each request
    },
    credentials: 'include', // Automatically sends httpOnly cookies
    api: authenticatedFetch,
  } as InitClientArgs

  clientInstance = initClient(contract, config)
  return clientInstance
}

// Reset client singleton (e.g., after logout)
export const resetClient = () => {
  clientInstance = null
}
